import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { HStack } from '../Core';
import { Icon } from '../Icons';

export const BreadcrumbWrapper = styled(HStack)`
  justify-content: flex-start;
  flex: 0 1 auto;
  overflow: hidden;
`;

export const breadcrumbItemCss = css<{ $isLast?: boolean }>`
  display: inline-block;
  padding: ${({ theme }) => `${theme.spacing4}px`};
  border-radius: ${({ theme }) => theme.borderRadiusDefault}px;
  border-bottom: unset;
  color: ${({ theme, $isLast }) => ($isLast ? theme.colorTextAttention : theme.colorTextDefault)};
  font-size: ${({ theme }) => theme.fontSizeSmall}rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const breadcrumbItemHoverCss = css`
  &:hover {
    color: ${({ theme }) => theme.colors.gray['100']};
    ${Icon} {
      color: ${({ theme }) => theme.colors.gray['100']};
    }
  }
`;

export const BreadcrumbItemLink = styled(Link)<{ $isLast?: boolean }>`
  ${breadcrumbItemCss}
  ${breadcrumbItemHoverCss}
`;

export const BreadcrumbItemButton = styled.button<{ $isLast?: boolean }>`
  ${breadcrumbItemCss}
  ${breadcrumbItemHoverCss}
  appearance: none;
  background: transparent;
  border: none;
  font: inherit;
  cursor: pointer;
`;

export const BreadcrumbItemCurrent = styled.span<{ $isLast?: boolean }>`
  ${breadcrumbItemCss}
`;
